var DualRowPackageData = require('./dualRowPackageData.js');
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var PathData = require('../../../svg/pathData.js');
var PathObjectData = require('../../../svg/pathObjectData.js');
var PathType = require('../../../svg/pathType.js');
var IPCRules = require('../ipcRules');
var ComponentAttribute = require('./componentAttribute.js');

var AluminumElectrolyticData = function(position, angle, init) {
    var self = this;

    DualRowPackageData.apply(self, arguments);

    //center gap between leads at opposite sides
    this.terminalGapMax = this.value("terminalGapMax", true);
    this.terminalGapMin = this.value("terminalGapMin", true);
    this.optionalDimension = this.value("optionalDimension", true);
    
    this.nonTransformedSegmentedGeometry.addTrigger(this.terminalGapMax);
    this.nonTransformedSegmentedGeometry.addTrigger(this.terminalGapMin);
    this.optionalDimension(ComponentAttribute.optionalDimensionInput["Optional_D"]);
    
    this.optionalDimension.onChange(this, function(value) {
        self.setupMinMaxPtrMap()
    });
};

lib_core.inherit(AluminumElectrolyticData, DualRowPackageData);
lib_core.JsonParser.registerClass(AluminumElectrolyticData, "AluminumElectrolyticData");

module.exports = AluminumElectrolyticData;


AluminumElectrolyticData.prototype.setupMinMaxPtrMap = function() {
    DualRowPackageData.prototype.setupMinMaxPtrMap.call(this);
    //remove input validate for optional dimension
    this.minMaxPointerMap["terminalGap"] = [this.terminalGapMin, this.terminalGapMax];
    this.validationMap["terminalGapMax"] = [this.terminalGapMax];
    if (this.optionalDimension() === ComponentAttribute.optionalDimensionInput["Optional_D"]) {
        delete this.validationMap["horizontalLeadToLeadSpanMax"]
        delete this.minMaxPointerMap["horizontalLeadToLeadSpan"]  
    } else if (this.optionalDimension() === ComponentAttribute.optionalDimensionInput["Optional_D2"]) {
        delete this.validationMap["terminalGapMax"]
        delete this.minMaxPointerMap["terminalGap"]
    } else if (this.optionalDimension() === ComponentAttribute.optionalDimensionInput["Optional_L"]) {
        delete this.validationMap["padWidthMax"]
        delete this.minMaxPointerMap["padWidth"]
    }   
};

//no pin marker for this package
AluminumElectrolyticData.prototype.getSilkscreen = function(pads) {
    var self = this;

    var silkscreen = [];

    //no silkscreen if there are no pads
    if(pads.length === 0) return silkscreen;

    //get body dimesnsions depending on mapping type of silkscreen to body
    var body = self.getBodyForSilkscreen();
    var firstPad = pads[0];

    //top silkscreen
    var pathData = new PathData(new lib_geometry.Coord(-body.width / 2, firstPad.getPos().y + firstPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance), IPCRules.silkscreenStrokeWidth);
    pathData.addObject(new PathObjectData(new lib_geometry.Coord(-body.width / 2, body.height / 2 - IPCRules.silkscreenCornerClipPercentage * (body.height - firstPad.getTopCopper().height())), PathType.LINE));
    pathData.addObject(new PathObjectData(new lib_geometry.Coord(-body.width / 2 + IPCRules.silkscreenCornerClipPercentage * (body.width - firstPad.getTopCopper().height()), body.height / 2), PathType.LINE));
    pathData.addObject(new PathObjectData(new lib_geometry.Coord(body.width / 2, body.height / 2), PathType.LINE));
    pathData.addObject(new PathObjectData(new lib_geometry.Coord(body.width / 2, firstPad.getPos().y + firstPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance), PathType.LINE));
    silkscreen.push(pathData);

    //bottom silkscreen
    pathData = pathData.clone();

    //flip around x axis
    pathData.flip(new lib_geometry.Line(lib_geometry.Line.HOR, new lib_geometry.Coord(0, 0)));
    silkscreen.push(pathData);

    return silkscreen;
};

